import React from "react";
import { ArrowL, ArrowR } from "./Arrows.styled";
import { sliderArrowLeft } from "../../../assets/img/sliderArrowLeft";
import { sliderArrowRight } from "../../../assets/img/sliderArrowRight";

export const ArrowsLeft = ({ onClick }) => {
  return <ArrowL onClick={onClick}>{sliderArrowLeft()}</ArrowL>;
};

export const ArrowsRight = ({ onClick }) => {
  return <ArrowR onClick={onClick}>{sliderArrowRight()}</ArrowR>;
};
